import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M99 93.62c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path fill="#ACB8C3" d="M19.92 40.44a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      d="M6.07 31.45a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M18.54 85.28l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM113.13 38.94h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5"
    />
    <path
      fill="#7B8493"
      d="M47.37 81.81c-.98 0-1.88-.65-2.16-1.63l-16.32-57.2H18.35c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25h12.24c1 0 1.89.67 2.16 1.63l16.17 56.66 46.56-13.22a2.25 2.25 0 0 1 2.78 1.55c.34 1.2-.35 2.44-1.55 2.78L47.99 81.71c-.21.06-.41.09-.62.09z"
    />
    <path
      fill="#ACB8C3"
      fillRule="evenodd"
      d="m83.62 60.06-26.96 7.58a3.89 3.89 0 0 1-4.8-2.69l-7.58-26.96a3.89 3.89 0 0 1 2.69-4.8l12.6-3.54 1.74-.49 12.62-3.55a3.89 3.89 0 0 1 4.8 2.69l7.58 26.96c.58 2.07-.62 4.22-2.7 4.8z"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="M45.53 93.7c6.672 0 12.08-5.408 12.08-12.08s-5.408-12.08-12.08-12.08-12.08 5.408-12.08 12.08S38.858 93.7 45.53 93.7"
    />
    <path
      fill="#C7D0D9"
      d="M45.53 86.28a4.66 4.66 0 1 0 0-9.32 4.66 4.66 0 0 0 0 9.32"
    />
    <mask
      id="enrichedIcon-PurchaseOrdersGreyscale_svg__a"
      width={43}
      height={43}
      x={44}
      y={25}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="m83.62 60.06-26.96 7.58a3.89 3.89 0 0 1-4.8-2.69l-7.58-26.96a3.89 3.89 0 0 1 2.69-4.8l12.6-3.54 1.74-.49 12.62-3.55a3.89 3.89 0 0 1 4.8 2.69l7.58 26.96c.58 2.07-.62 4.22-2.7 4.8z"
      />
    </mask>
    <g mask="url(#enrichedIcon-PurchaseOrdersGreyscale_svg__a)">
      <path
        fill="#C7D0D9"
        d="M62.97 39.66c-.98 0-1.89-.65-2.17-1.64l-2.58-9.17c-.34-1.2.36-2.44 1.56-2.77a2.24 2.24 0 0 1 2.77 1.56l2.58 9.17a2.236 2.236 0 0 1-2.17 2.85z"
      />
    </g>
  </svg>
);
const SvgEnrichedIconPurchaseOrdersGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconPurchaseOrdersGreyscale);
export default Memo;
